<template>
    <div class="step step-summary">
        <p v-html="step.description"></p>

        <b-row>
            <template v-for="field in orderFields(step.fields)">
                <b-col v-if="!field.hidden" v-bind:key="field.position" cols="12" :sm="field.size === 'short' ? 6 : 12">

                    <div v-if="getLabelFromSubmission(field)" class="summary-field mb-3">
                        <label v-if="field.type === 'label'" class="summary-label">{{ field.label }}</label>
                        <label v-if="field.type === 'label'" class="summary-value">
                            {{ getLabelFromSubmission(field) }}</label>
                    </div>

                    <b-form-checkbox v-if="field.type === 'checkbox'" :id="getFieldId(field.name, null)"
                                     :name="getFieldId(field.name, null)"
                                     v-model="submission.submissionValues[field.name]"
                                     :required="!!field.required"
                                     :class="['my-2', {'ckc-required' : field.required }]" :button="field.btnStyled"
                                     button-variant="primary" value="true" unchecked-value="false">
                        <span>
                            <span v-html="field.label"></span>
                            <b-link
                                @click="$parent.showHtmlModal(field.modalTitle ? field.modalTitle : 'Privacy Policy', field.modalHtmlContent)">
                                {{ field.linkText }}</b-link>
                        </span>
                    </b-form-checkbox>
                    <b-form-invalid-feedback :id="getFieldId(field.name, 'feedback')">
                        This field is required.
                    </b-form-invalid-feedback>
                </b-col>

            </template>
        </b-row>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "StepSummary",
        props: {
            portal: Object,
            step: Object,
            stepIndex: Number,
            submission: Object,
        },
        methods: {
            getFieldId(field, att) {
                if (att != null) {
                    return this.step.position + '-' + field + '-' + att;
                } else {
                    return this.step.position + '-' + field;
                }
            },
            orderFields(fields) {
                return _.orderBy(fields, 'position')
            },
            getLabelFromSubmission(field) {
                let fieldName, fieldValue;
                if (this.submission.submissionValues && field.name.startsWith('submission.')) {
                    fieldName = field.name.replace("submission.", "");
                    fieldValue = this.submission.submissionValues[fieldName];
                    if (field.linkedClass != null && fieldValue) {
                        return field.fieldValues[fieldValue].label;
                    }
                    return fieldValue;
                } else if (this.submission.submitterValues && field.name.startsWith('submitter.')) {
                    fieldName = field.name.replace("submitter.", "");
                    fieldValue = Object.values(this.submission.submitterValues)[0][fieldName];
                    if (field.linkedClass != null && fieldValue) {
                        return field.fieldValues[fieldValue].label;
                    }
                    return fieldValue;
                }
                return null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .summary-field {
        .summary-label {
            display: block;
            font-weight: bold;
        }
    }
</style>